import React from 'react';
import moment from 'moment/moment';
import {DefaultCell} from '../Table';

const ClosedItems = ({
  action,
  setModalStatus,
  setChosenCorrectiveAction,
  rowIndex,
  cellKeys,
}) => (
  <tr
    className='table-row'
    key={action.id}
    style={{
      gridTemplateColumns: `repeat(${cellKeys.length}, 1fr)`,
    }}
    onClick={() => {
      setModalStatus(true);
      setChosenCorrectiveAction(action);
    }}
  >
    <DefaultCell
      value={
        action?.created_at
          ? moment.parseZone(action.created_at).format('MM/DD/YYYY')
          : '---'
      }
      index={'created_at'}
      rowIndex={rowIndex}
    />
    <DefaultCell
      value={
        action.closed_time
          ? moment(action.closed_time).format('MM/DD/YYYY')
          : '---'
      }
      index={'closed_time'}
      rowIndex={rowIndex}
    />
    <DefaultCell
      value={action.facility_title ? action.facility_title : '---'}
      index={'facility_title'}
      rowIndex={rowIndex}
    />
    <DefaultCell
      value={action.equipment_type_title ? action.equipment_type_title : '---'}
      index={'equipment_type_title'}
      rowIndex={rowIndex}
    />
    <DefaultCell
      value={action.equipment_title ? action.equipment_title : '---'}
      index={'equipment_title'}
      rowIndex={rowIndex}
    />
    <DefaultCell
      value={`${action.inspection_title ? action.inspection_title : '---'} / ${action.category_title ? action.category_title : '---'}`}
      index={'inspection_title'}
      rowIndex={rowIndex}
    />
    <DefaultCell
      value={action.discrepancy ? action.discrepancy : '---'}
      index={'discrepancy'}
      rowIndex={rowIndex}
    />
    <DefaultCell
      value={action.comment || '---'}
      index={'comment'}
      rowIndex={rowIndex}
    />
    <DefaultCell
      value={action.action ? action.action : '---'}
      index={'action'}
      rowIndex={rowIndex}
    />
    <DefaultCell
      value={action.closed_by_name ? action.closed_by_name : '---'}
      index={'closed_by_name'}
      rowIndex={rowIndex}
    />
  </tr>
);

export default ClosedItems;
